import { Typography } from "@/components/ui/typography";
import { JSX } from "react";

export const WhyItem = ({
  item,
}: {
  item: {
    icon: JSX.Element;
    title: string;
    description: string;
  };
}) => {
  return (
    <div className="flex flex-col gap-8 items-center flex-1 h-full">
      <div className="bg-[#121212] bg-[linear-gradient(180deg,rgba(51,221,127,0.2)_18.75%,rgba(0,0,0,0.2)_100%)] border-3 border-primary w-32 h-32 rounded-full flex justify-center items-center text-5xl shadow-[0px_0px_30px_0px_#33DD7F]">
        {item.icon}
      </div>
      <div className="flex flex-col gap-3 flex-1">
        <Typography className="font-semibold text-center text-white">
          {item.title}
        </Typography>
        <Typography className="text-center max-lg:block max-xl:hidden">
          {item.description}
        </Typography>
      </div>
    </div>
  );
};
